import { CommonModule, DatePipe } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { TuiTable } from '@taiga-ui/addon-table';
import { TuiButton, TuiHint } from '@taiga-ui/core';
import { TuiComment, TuiPdfViewerOptions, TuiPdfViewerService } from '@taiga-ui/kit';
import { ObsPipe } from '../../pipes/obs.pipe';
import { ObsStatutPipe } from '../../pipes/obs-statut.pipe';
import { IahResiduelPipe } from '../../pipes/iah-residuel.pipe';
import { IahResiduelStatutPipe } from '../../pipes/iah-residuel-statut.pipe';
import { FuitesPipe } from '../../pipes/fuites.pipe';
import { FuitesStatutPipe } from '../../pipes/fuites-statut.pipe';
import { PressionPipe } from '../../pipes/pression.pipe';
import { Intervention } from '../../models/intervention';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DocumentService } from '../../services/document.service';
import { Subscription } from 'rxjs';
import type { PolymorpheusContent } from '@taiga-ui/polymorpheus';

@Component({
  selector: 'app-intervention-row',
  standalone: true,
  imports: [
    TuiTable,
    TuiComment,
    DatePipe,
    CommonModule,
    TuiHint,
    TuiButton,
    ObsPipe,
    ObsStatutPipe,
    IahResiduelPipe,
    IahResiduelStatutPipe,
    FuitesPipe,
    FuitesStatutPipe,
    PressionPipe,
  ],
  templateUrl: './intervention-row.component.html',
  styleUrl: './intervention-row.component.scss'
})
export class InterventionRowComponent {
  @Input() intervention: Intervention | undefined;
  @Input() format: string | undefined;

  private readonly sanitizer = inject(DomSanitizer);
  private readonly pdfService = inject(TuiPdfViewerService);
  private readonly documentService = inject(DocumentService);

  private subscriptionChargementDonneePatient: Subscription | undefined;

  isNumber(varTest: any): boolean {
    return typeof varTest == 'number';
  }

  number(varTest: any): number {
    return parseFloat(varTest);
  }

  protected show(
    actions: PolymorpheusContent<TuiPdfViewerOptions>,
    id: number,
    titre: string
  ): void {
    this.documentService.pullFile(id).subscribe({
      next: (blob) => {
        // Créer une URL sécurisée
        const url: SafeResourceUrl =
          this.sanitizer.bypassSecurityTrustResourceUrl(
            URL.createObjectURL(blob)
          );

        // Passer cette URL au `pdfService`
        this.pdfService
          .open(url, {
            label: titre,
            actions,
          })
          .subscribe();
      },
      error: (err) => {
        console.error('Erreur lors du chargement du PDF :', err);
      },
    });
  }

  ngOnDestroy(): void {
    if (this.subscriptionChargementDonneePatient) {
      this.subscriptionChargementDonneePatient.unsubscribe();
    }
  }
}
